var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.activity.description)+":")]),_c('div',{staticClass:"bg-gray-50 mt-4 rounded-xl p-6"},[_c('h4',{staticClass:"text-black font-semibold"},[_vm._v(_vm._s(_vm.activity.properties.question))]),_c('p',[_vm._v(_vm._s(_vm.activity.properties.answer))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }